<template>
  <div>
    <h3>Administrationsveje</h3>
    <div class="routeStatusFilters">
      <BaseRadioButton
        v-model="filterBy"
        name="filterby"
        store="all"
        label="Alle"
      />
      <BaseRadioButton
        v-model="filterBy"
        name="filterby"
        store="active"
        label="Aktive"
      />
      <BaseRadioButton
        v-model="filterBy"
        name="filterby"
        store="inactive"
        label="Inaktive"
      />
    </div>

    <div
      class="row"
      v-if="formattedStatuses.length"
    >
      <div class="col-xs-4 col-xs-offset-4">
        <strong>Konkurrence</strong>
      </div>
      <div class="col-xs-4">
        <strong>Træning</strong>
      </div>
    </div>
    <div
      class="row routeStatus"
      v-for="route in formattedStatuses"
      :key="route.id"
    >
      <div class="col-xs-4">
        <span
          class="routeStatus__name"
          :class="{'routeStatus__name--inactive': !route.active}"
        >{{ route.name }}</span>
      </div>
      <div class="col-xs-4 routeStatus__picker">
        <IconPicker
          :extended="true"
          v-model="route.statusCompetition"
          @input="detectFirstChange(route, $event)"
        />
        <font-awesome-icon
          icon="times"
          class="deselecter"
          v-if="route.statusCompetition != -1"
          @click="reset(route, 'statusCompetition')"
        />
      </div>
      <div class="col-xs-4 routeStatus__picker">
        <IconPicker
          :extended="true"
          v-model="route.statusTraining"
          @input="detectFirstChange(route, $event)"
        />
        <font-awesome-icon
          icon="times"
          class="deselecter"
          v-if="route.statusTraining != -1"
          @click="reset(route, 'statusTraining')"
        />
      </div>
    </div>
  </div>
</template>

<script>
import BaseRadioButton from './BaseRadioButton.vue';
import IconPicker from './IconPicker.vue';

export default {
    name: 'RouteOfAdministrationStatuses',
    components: { IconPicker, BaseRadioButton },
    props: {
        statuses: { type: Array, required: true },
    },
    data() {
        return {
            filterBy: 'active',
        };
    },
    computed: {
        formattedStatuses() {
            return this.statuses.filter((status) => {
                if (this.filterBy === 'active') {
                    return status.active === true;
                }

                if (this.filterBy === 'inactive') {
                    return status.active === false;
                }

                return true;
            });
        },
    },
    methods: {
        detectFirstChange(route, iconID) {
            if (route.updatedOnce === false) {
                this.$set(route, 'updatedOnce', true);
                this.$set(route, 'statusCompetition', iconID);
                this.$set(route, 'statusTraining', iconID);
            }
        },
        reset(route, type) {
            this.$set(route, type, -1);
        },
    },
};
</script>

<style lang="scss" scoped>
.routeStatusFilters {
    display: flex;
    justify-content: center;
    margin-bottom: 20px;
}
.routeStatus {
    margin-bottom: 5px;

    &__name {
        &--inactive {
            color: $gray;
        }
    }

    &__picker {
        display: flex;
        align-items: center;

        .deselecter {
            margin-left: 5px;
            color: $red;
            cursor: pointer;
        }
    }
}
</style>
